"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightTheme = exports.DarkTheme = exports.Themes = exports.CustomisationDataStruct = void 0;
const superstruct_1 = require("superstruct");
exports.CustomisationDataStruct = (0, superstruct_1.type)({
    buttonColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    headerColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    backgroundColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    textColor: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    theme: (0, superstruct_1.optional)((0, superstruct_1.enums)(['light', 'dark'])),
    favIcon: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    bookingBaseUrl: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
exports.Themes = (0, superstruct_1.enums)(['light', 'dark']);
exports.DarkTheme = {
    buttonColor: '#7669ff',
    headerColor: '#7669ff',
    backgroundColor: '#2C353F',
    textColor: '#fff',
    theme: 'dark',
};
exports.LightTheme = {
    buttonColor: '#7669ff',
    headerColor: '#e8e6ff',
    backgroundColor: '#fff',
    textColor: '#2C353F',
    theme: 'light',
};
//# sourceMappingURL=customisation.js.map